import React from 'react';

const SvgNotInvitationSent: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 -1 24 24" {...props}>
    <path
      d="M18.8183 4.48048C19.0177 4.41077 19.2393 4.46198 19.3887 4.61134C19.538 4.76069 19.5892 4.98227 19.5195
      5.18165L14.6191 19.1816C14.5446 19.3945 14.3474 19.5406 14.1221 19.5498C13.925 19.5577 13.7409 19.4596 13.6367
      19.2969L13.5976 19.2236L10.8828 13.1162L4.77635 10.4024L4.70311 10.3633C4.54043 10.2591 4.44227 10.075 4.45018
      9.87794C4.45938 9.65261 4.6055 9.45536 4.81835 9.38087L18.8183 4.48048ZM11.9551 12.8213L14.039 17.5088L17.6836
      7.09278L11.9551 12.8213ZM6.49022 9.95997L11.1777 12.044L16.9062 6.31544L6.49022 9.95997Z"
      fill="#99A3AC"
    />
  </svg>
);

export default SvgNotInvitationSent;
